import { CprType, HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '../../models';
import { SYSTEM_ENUM_ROOT } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Credential Process Request Type`;

export type CPCprTypeLocs =
	| 'CPCprTypeEnumCertRebuild'
	| 'CPCprTypeEnumCertRebuildBulk'
	| 'CPCprTypeEnumCertRegression'
	| 'CPCprTypeEnumInvalid'
	| 'CPCprTypeEnumMaintenance'
	| 'CPCprTypeEnumManualAdjustment'
	| 'CPCprTypeEnumManualCertify'
	| 'CPCprTypeEnumManualExtension'
	| 'CPCprTypeEnumManualReduction'
	| 'CPCprTypeEnumNormal'
	| 'CPCprTypeEnumNormalInRebuild'
	| 'CPCprTypeEnumNormalWithoutTree';

export type SPCprTypeLocs =
	| 'SPCprTypeEnumCertRebuild'
	| 'SPCprTypeEnumCertRebuildBulk'
	| 'SPCprTypeEnumCertRegression'
	| 'SPCprTypeEnumInvalid'
	| 'SPCprTypeEnumMaintenance'
	| 'SPCprTypeEnumManualAdjustment'
	| 'SPCprTypeEnumManualCertify'
	| 'SPCprTypeEnumManualExtension'
	| 'SPCprTypeEnumManualReduction'
	| 'SPCprTypeEnumNormal'
	| 'SPCprTypeEnumNormalInRebuild'
	| 'SPCprTypeEnumNormalWithoutTree';

export const cpCprTypeEnumLocs: LocDefs<CPCprTypeLocs> = {
	CPCprTypeEnumCertRebuild: {
		defaultValue: 'Certification Rebuild',
		displayPath: `${dpRoot}|${CprType.CertRebuild}`,
		description: `Credential process request type: '${CprType.CertRebuild}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprTypeEnumCertRebuildBulk: {
		defaultValue: 'Bulk Certification Rebuild',
		displayPath: `${dpRoot}|${CprType.CertRebuildBulk}`,
		description: `Credential process request type: '${CprType.CertRebuildBulk}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprTypeEnumCertRegression: {
		defaultValue: 'Certification Regression',
		displayPath: `${dpRoot}|${CprType.CertRegression}`,
		description: `Credential process request type: '${CprType.CertRegression}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprTypeEnumInvalid: {
		defaultValue: 'Invalid',
		displayPath: `${dpRoot}|${CprType.Invalid}`,
		description: `Credential process request type: '${CprType.Invalid}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprTypeEnumMaintenance: {
		defaultValue: 'Maintenance',
		displayPath: `${dpRoot}|${CprType.Maintenance}`,
		description: `Credential process request type: '${CprType.Maintenance}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprTypeEnumManualAdjustment: {
		defaultValue: 'Manual Adjustment',
		displayPath: `${dpRoot}|${CprType.ManualAdjustment}`,
		description: `Credential process request type: '${CprType.ManualAdjustment}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprTypeEnumManualCertify: {
		defaultValue: 'Manual Certify',
		displayPath: `${dpRoot}|${CprType.ManualCertify}`,
		description: `Credential process request type: '${CprType.ManualCertify}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprTypeEnumManualExtension: {
		defaultValue: 'Manual Extension',
		displayPath: `${dpRoot}|${CprType.ManualExtension}`,
		description: `Credential process request type: '${CprType.ManualExtension}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprTypeEnumManualReduction: {
		defaultValue: 'Manual Reduction',
		displayPath: `${dpRoot}|${CprType.ManualReduction}`,
		description: `Credential process request type: '${CprType.ManualReduction}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprTypeEnumNormal: {
		defaultValue: 'Normal',
		displayPath: `${dpRoot}|${CprType.Normal}`,
		description: `Credential process request type: '${CprType.Normal}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprTypeEnumNormalInRebuild: {
		defaultValue: 'Normal In Rebuild',
		displayPath: `${dpRoot}|${CprType.NormalInRebuild}`,
		description: `Credential process request type: '${CprType.NormalInRebuild}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprTypeEnumNormalWithoutTree: {
		defaultValue: 'Normal Without Tree',
		displayPath: `${dpRoot}|${CprType.NormalWithoutTree}`,
		description: `Credential process request type: '${CprType.NormalWithoutTree}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
};

export const spCprTypeEnumLocs: LocDefs<SPCprTypeLocs> = {
	SPCprTypeEnumCertRebuild: {
		defaultValue: 'Certification Rebuild',
		displayPath: `${dpRoot}|${CprType.CertRebuild}`,
		description: `Credential process request type: '${CprType.CertRebuild}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprTypeEnumCertRebuildBulk: {
		defaultValue: 'Bulk Certification Rebuild',
		displayPath: `${dpRoot}|${CprType.CertRebuildBulk}`,
		description: `Credential process request type: '${CprType.CertRebuildBulk}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprTypeEnumCertRegression: {
		defaultValue: 'Certification Regression',
		displayPath: `${dpRoot}|${CprType.CertRegression}`,
		description: `Credential process request type: '${CprType.CertRegression}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprTypeEnumInvalid: {
		defaultValue: 'Invalid',
		displayPath: `${dpRoot}|${CprType.Invalid}`,
		description: `Credential process request type: '${CprType.Invalid}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprTypeEnumMaintenance: {
		defaultValue: 'Maintenance',
		displayPath: `${dpRoot}|${CprType.Maintenance}`,
		description: `Credential process request type: '${CprType.Maintenance}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprTypeEnumManualAdjustment: {
		defaultValue: 'Manual Adjustment',
		displayPath: `${dpRoot}|${CprType.ManualAdjustment}`,
		description: `Credential process request type: '${CprType.ManualAdjustment}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprTypeEnumManualCertify: {
		defaultValue: 'Manual Certify',
		displayPath: `${dpRoot}|${CprType.ManualCertify}`,
		description: `Credential process request type: '${CprType.ManualCertify}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprTypeEnumManualExtension: {
		defaultValue: 'Manual Extension',
		displayPath: `${dpRoot}|${CprType.ManualExtension}`,
		description: `Credential process request type: '${CprType.ManualExtension}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprTypeEnumManualReduction: {
		defaultValue: 'Manual Reduction',
		displayPath: `${dpRoot}|${CprType.ManualReduction}`,
		description: `Credential process request type: '${CprType.ManualReduction}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprTypeEnumNormal: {
		defaultValue: 'Normal',
		displayPath: `${dpRoot}|${CprType.Normal}`,
		description: `Credential process request type: '${CprType.Normal}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprTypeEnumNormalInRebuild: {
		defaultValue: 'Normal In Rebuild',
		displayPath: `${dpRoot}|${CprType.NormalInRebuild}`,
		description: `Credential process request type: '${CprType.NormalInRebuild}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprTypeEnumNormalWithoutTree: {
		defaultValue: 'Normal Without Tree',
		displayPath: `${dpRoot}|${CprType.NormalWithoutTree}`,
		description: `Credential process request type: '${CprType.NormalWithoutTree}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
};

export const CPR_TYPE_ENUM_LOCS = MapLocKeys<CPCprTypeLocs | SPCprTypeLocs>({
	...cpCprTypeEnumLocs,
	...spCprTypeEnumLocs,
});

export type CPCprTypeEnumLocType = LocMap<CPCprTypeLocs>;
export type SPCprTypeEnumLocType = LocMap<SPCprTypeLocs>;

export const cpCprTypeKeys: { [key in CprType]: keyof CPCprTypeEnumLocType } = {
	[CprType.CertRebuild]: CPR_TYPE_ENUM_LOCS.CPCprTypeEnumCertRebuild,
	[CprType.CertRebuildBulk]: CPR_TYPE_ENUM_LOCS.CPCprTypeEnumCertRebuildBulk,
	[CprType.CertRegression]: CPR_TYPE_ENUM_LOCS.CPCprTypeEnumCertRegression,
	[CprType.Invalid]: CPR_TYPE_ENUM_LOCS.CPCprTypeEnumInvalid,
	[CprType.Maintenance]: CPR_TYPE_ENUM_LOCS.CPCprTypeEnumMaintenance,
	[CprType.ManualAdjustment]: CPR_TYPE_ENUM_LOCS.CPCprTypeEnumManualAdjustment,
	[CprType.ManualCertify]: CPR_TYPE_ENUM_LOCS.CPCprTypeEnumManualCertify,
	[CprType.ManualExtension]: CPR_TYPE_ENUM_LOCS.CPCprTypeEnumManualExtension,
	[CprType.ManualReduction]: CPR_TYPE_ENUM_LOCS.CPCprTypeEnumManualReduction,
	[CprType.Normal]: CPR_TYPE_ENUM_LOCS.CPCprTypeEnumNormal,
	[CprType.NormalInRebuild]: CPR_TYPE_ENUM_LOCS.CPCprTypeEnumNormalInRebuild,
	[CprType.NormalWithoutTree]: CPR_TYPE_ENUM_LOCS.CPCprTypeEnumNormalWithoutTree,
};

export const spCprTypeKeys: { [key in CprType]: keyof SPCprTypeEnumLocType } = {
	[CprType.CertRebuild]: CPR_TYPE_ENUM_LOCS.SPCprTypeEnumCertRebuild,
	[CprType.CertRebuildBulk]: CPR_TYPE_ENUM_LOCS.SPCprTypeEnumCertRebuildBulk,
	[CprType.CertRegression]: CPR_TYPE_ENUM_LOCS.SPCprTypeEnumCertRegression,
	[CprType.Invalid]: CPR_TYPE_ENUM_LOCS.SPCprTypeEnumInvalid,
	[CprType.Maintenance]: CPR_TYPE_ENUM_LOCS.SPCprTypeEnumMaintenance,
	[CprType.ManualAdjustment]: CPR_TYPE_ENUM_LOCS.SPCprTypeEnumManualAdjustment,
	[CprType.ManualCertify]: CPR_TYPE_ENUM_LOCS.SPCprTypeEnumManualCertify,
	[CprType.ManualExtension]: CPR_TYPE_ENUM_LOCS.SPCprTypeEnumManualExtension,
	[CprType.ManualReduction]: CPR_TYPE_ENUM_LOCS.SPCprTypeEnumManualReduction,
	[CprType.Normal]: CPR_TYPE_ENUM_LOCS.SPCprTypeEnumNormal,
	[CprType.NormalInRebuild]: CPR_TYPE_ENUM_LOCS.SPCprTypeEnumNormalInRebuild,
	[CprType.NormalWithoutTree]: CPR_TYPE_ENUM_LOCS.SPCprTypeEnumNormalWithoutTree,
};
